import { Injectable } from '@angular/core';
import { FirebaseData } from '../../../providers/firebase-data';
import { FirebaseStorage } from '../../../providers/firebase-storage';
import { Storage } from '@ionic/storage'; 
import firebase from 'firebase';
import { FireBaseObjectNames, LocalStorageCodes } from '../../../core/codes';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SpecialData {
    public realtimeDb: any;

    constructor(
        private firebaseData: FirebaseData, 
        private firebaseStorage: FirebaseStorage,
        private storage: Storage,
        public afw: AngularFireDatabaseWrapper,
        ) {
      this.realtimeDb = firebase.database();
    }

    public getAllDamCategories() {
        let strgRef = FireBaseObjectNames.DAM_CATEGORIES;
        var result = this.afw.list(strgRef).map(val => {
            this.storage.set(strgRef, JSON.stringify(val));
            return val;
        });
        return result;
    }

    public getLocalDamProducts() {
        return Observable.fromPromise(this.storage.get(LocalStorageCodes.DAM_PRODUCTS))
            .map(val => {
                return val ? JSON.parse(val) : null;
            });
    }

    public getAllDamProductsFullData() {
        let strgRef = FireBaseObjectNames.DAM_PRODUCTS;
        var result = this.afw.list(strgRef).map(val => {
            this.storage.set(strgRef, JSON.stringify(val));
            return val;
        });
        return result;
    }

    public getDamProductsbyCatgoryData(categoryId) {
        // let strgRef = FireBaseObjectNames.DAM_PRODUCTS;
        // var result = this.afw.list(strgRef).map(val => {
        //     this.storage.set(strgRef, JSON.stringify(val));
        //     return val;
        // });
        // return result;
    }
}


// WEBPACK FOOTER //
// ./src/modules/special/providers/special-data.ts